export const GET_EXAMS = 'GET_EXAMS'
export const GET_STUDENT_EXAMS = 'GET_STUDENT_EXAMS'
export const VIEW_SELECTED_EXAM = 'VIEW_SELECTED_EXAM'
export const ADD_EXAM = 'ADD_EXAM'
export const UPDATE_EXAM = 'UPDATE_EXAM'
export const DELETE_SINGLE_EXAM = 'DELETE_SINGLE_EXAM'
export const DELETE_MANY_EXAMS = 'DELETE_MANY_EXAMS'
export const SEND_EXAM_NOTIFICATION = 'SEND_EXAM_NOTIFICATION'
export const SEND_EXAM_SMS = 'SEND_EXAM_SMS'
export const GET_EXAM_LABELS = 'GET_EXAM_LABELS'
export const GET_EXAM_SETUP_STATUS = 'GET_EXAM_SETUP_STATUS'
export const GET_STUDENT_EXAM_REPORT_CARDS = 'GET_STUDENT_EXAM_REPORT_CARDS'
export const GET_STUDENT_PREVIOUS_SESSION_EXAM_REPORT_CARDS =
  'GET_STUDENT_PREVIOUS_SESSION_EXAM_REPORT_CARDS'
export const FETCH_STUDENT_ACADEMIC_COMMENTS = 'FETCH_STUDENT_ACADEMIC_COMMENTS'
export const SAVE_STUDENT_ACADEMIC_COMMENTS = 'SAVE_STUDENT_ACADEMIC_COMMENTS'
export const GET_ALL_GRADING_KEY = 'GET_ALL_GRADING_KEY'
export const CREATE_GRADING_KEY = 'CREATE_GRADING_KEY'
export const VIEW_GRADING_KEY = 'VIEW_GRADING_KEY'
export const GET_GRADING_KEY_TEMPLATE = 'GET_GRADING_KEY_TEMPLATE'
export const SAVE_GRADING_KEY_TEMPLATE = 'SAVE_GRADING_KEY_TEMPLATE'
export const DELETE_GRADING_KEY = 'DELETE_GRADING_KEY'
export const DELETE_MANY_GRADING_KEY = 'DELETE_MANY_GRADING_KEY'
export const UPDATE_GRADING_KEY = 'UPDATE_GRADING_KEY'
export const MISSING_GRADING_KEY = 'MISSING_GRADING_KEY'
export const GET_EXAM_GRADES = 'GET_EXAM_GRADES'
export const GENERATE_ACADEMIC_PERFORMANCE_REPORT = 'GENERATE_ACADEMIC_PERFORMANCE_REPORT'
export const DOWNLOAD_REPORT_CARD_PDF = 'DOWNLOAD_REPORT_CARD_PDF'
export const GET_EXAM_RESULTS = 'GET_EXAM_RESULTS'
export const UPDATE_EXAM_RESULT = 'UPDATE_EXAM_RESULT'
export const ASSIGN_EXAM_MARKS_TO_ALL = 'ASSIGN_EXAM_MARKS_TO_ALL'
export const GET_EXAM_GRACE_MARKS = 'GET_EXAM_GRACE_MARKS'
export const SAVE_EXAM_GRACE_MARKS = 'SAVE_EXAM_GRACE_MARKS'
export const GET_EXAM_TYPE_WEIGHTAGES = 'GET_EXAM_TYPE_WEIGHTAGES'
export const SAVE_EXAM_TYPE_WEIGHTAGES = 'SAVE_EXAM_TYPE_WEIGHTAGES'
export const GET_REPORT_CARD_RESULTS = 'GET_REPORT_CARD_RESULTS'
export const GET_REPORT_CARD_RESULT_STUDENTS = 'GET_REPORT_CARD_RESULT_STUDENTS'
export const PUBLISH_REPORT_CARDS = 'PUBLISH_REPORT_CARDS'
export const SEND_REPORT_CARD_NOTIFICATION = 'SEND_REPORT_CARD_NOTIFICATION'
export const SEND_REPORT_CARD_MAIL = 'SEND_REPORT_CARD_MAIL'
export const UPDATE_REPORT_CARD_RESULT = 'UPDATE_REPORT_CARD_RESULT'
export const DELETE_REPORT_CARD_RESULT = 'DELETE_REPORT_CARD_RESULT'
export const GET_SKILL_REPORTS = 'GET_SKILL_REPORTS'
export const GET_SKILL_REPORT_SHEET = 'GET_SKILL_REPORT_SHEET'
export const SAVE_SKILL_REPORT_SHEET = 'SAVE_SKILL_REPORT_SHEET'
export const GET_STUDENT_VARIABLE_VALUES = 'GET_STUDENT_VARIABLE_VALUES'
export const SAVE_ALL_STUDENT_VARIABLE_VALUES = 'SAVE_ALL_STUDENT_VARIABLE_VALUES'
export const GET_REPORT_CARD_SETTINGS = 'GET_REPORT_CARD_SETTINGS'
export const SAVE_REPORT_CARD_SETTINGS = 'SAVE_REPORT_CARD_SETTINGS'
export const GET_REPORT_CARD_EXTRA_PARAMETERS = 'GET_REPORT_CARD_EXTRA_PARAMETERS'
export const SAVE_REPORT_CARD_EXTRA_PARAMETERS = 'SAVE_REPORT_CARD_EXTRA_PARAMETERS'
export const DELETE_REPORT_CARD_EXTRA_PARAMETER = 'DELETE_REPORT_CARD_EXTRA_PARAMETER'
export const SAVE_STUDENT_VARIABLE_VALUES = 'SAVE_STUDENT_VARIABLE_VALUES'
export const RECORD_ITEM_VIEW = 'RECORD_ITEM_VIEW'
